<template>
  <div class="catalog-form">
    <h1 id="init">
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>

      <div class="top-tool-bar flat actions">
        <div class="action" title="Refrescar registro para obtener las últimas actualizaciones" v-if="id && readOnly && readPermission" @click="sincronizeForm" variant="outline-info"><i class="fal fa-sync"></i> Refrescar</div>
        <div class="action" title="Modificar" v-if="id && readOnly && updatePermission" @click="changeEditMode" variant="outline-secondary"><i class="fal fa-file-edit"></i> Modificar</div>
        <div class="action" title="Eliminar" v-if="id && readOnly && deletePermission" @click="deleteItem" variant="outline-danger"><i class="fal fa-trash-alt"></i> Eliminar</div>
      </div>
    </h1>

    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#general" class="list-group-item list-group-item-action" aria-current="true">
          Información general
        </a>
        <a href="#roles" class="list-group-item list-group-item-action" aria-current="true">
          Roles
        </a>
        <a v-if="id" href="#history" class="list-group-item list-group-item-action" aria-current="true">
          Actualizaciones
        </a>
      </div>
    </div>

    <div class="form-area">
      <b-form @submit.stop.prevent="onSubmit" v-show="!loading">
        <!-- INFORMACION GENERAL -->
        <b-card id="general" header="Información general" class="form-section">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
              id="input-group-name"
              label="Nombre"
              label-for="input-name">
              <b-form-input
                id="input-name"
                name="input-name"
                type="text"
                class="shadow-none"
                v-model.trim="form.name"
                :disabled="true">
              </b-form-input>
              <small class="text-muted">Nombre generado con base en el recurso y el efecto.</small>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
            id="input-group-domain"
            label="Dominio"
            label-for="input-domain">
            <b-form-select
              id="input-domain"
              name="input-domain"
              type="number"
              class="shadow-none"
              v-model.trim="form.domain"
              :options="domainOptions"
              v-validate="{ required: true }"
              :state="validateState('input-domain')"
              aria-describedby="input-zipcode-feedback"
              :disabled="true">
            </b-form-select>
            <small class="text-muted">ID Dominio: {{form.domain}}</small>
            <b-form-invalid-feedback id="input-domain-feedback">Dominio requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
            id="input-group-resource"
            label="Recurso *"
            label-for="input-resource">
            <b-form-input
              id="input-resource"
              name="input-resource"
              type="text"
              class="shadow-none"
              placeholder="Recurso (Ej. templates, fills, clients)"
              v-model.trim="form.resource"
              v-validate="{ required: true }"
              :state="validateState('input-resource')"
              aria-describedby="input-resource-feedback"
              :disabled="readOnly"
              :title="form.resource.length > 30 ? form.resource : ''"
              @keyup="createName">
            </b-form-input>
            <b-form-invalid-feedback id="input-resource-feedback">Recurso requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
            id="input-group-effect"
            label="Efecto *"
            label-for="input-effect">
            <b-form-input
              id="input-effect"
              name="input-effect"
              type="text"
              class="shadow-none"
              placeholder="Effect (Ej. create, read, update, delete)"
              v-model.trim="form.effect"
              v-validate="{ required: true }"
              :state="validateState('input-effect')"
              aria-describedby="input-effect-feedback"
              :disabled="readOnly"
              @keyup="createName">
            </b-form-input>
            <b-form-invalid-feedback id="input-effect-feedback">Efecto requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
            id="input-group-label"
            label="Etiqueta"
            label-for="input-label">
            <b-form-input
              id="input-label"
              name="input-label"
              type="text"
              class="shadow-none"
              placeholder="Breve descripción del permiso"
              v-model.trim="form.label"
              :disabled="readOnly">
            </b-form-input>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
            id="radio-group-version"
            label="Versión *"
            label-for="radio-version">
            <b-form-radio-group
              id="radio-version"
              name="radio-version"
              class="shadow-none"
              v-model="form.version"
              v-validate="{ required: true }"
              :options="versionOptions"
              :state="validateVersion()"
              aria-describedby="radio-version-feedback"
              :disabled="readOnly">
              <b-form-invalid-feedback id="radio-version-feedback" :state="validateVersion()">Seleccionar versión</b-form-invalid-feedback>
            </b-form-radio-group>
              </b-form-group>
            </div>
          </div>
          <b-form-group
            id="input-group-description"
            label="Descripción"
            label-for="input-description">
            <b-form-textarea
              id="input-description"
              name="input-description"
              v-model="form.description"
              class="shadow-none"
              placeholder="Detalle del permiso..."
              rows="3"
              max-rows="6"
              :disabled="readOnly">
            </b-form-textarea>
          </b-form-group>

        </b-card>

        <!-- ROLES RELACIONADOS -->
        <b-card id="roles" header="Roles relacionados" class="form-section">
          <ItemsTable
            v-show="!loadingRoles"
            :available="!readOnly"
            :itemType="'Roles'"
            :items="relatedRoles"
            :mainItemColumns="filterRoles.basicFields"
            :mainAction="'remove'"
            :allItems="filterRoles.allRoles"
            @load-items="callLoadRoles"
            @update-items="updateRoles"
            @delete-items="deleteRoles"
            ></ItemsTable>
        </b-card>

        <!-- ACTUALIZACIONES -->
        <b-card id="history" header="Actualizaciones" class="form-section" v-if="id">
          <table class="table table-responsive-md">
            <thead>
              <tr>
                <th scope="col">Evento</th>
                <th scope="col">Usuario</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{ form.creationUser && form.creationUser.name || '---' }}</td>
                <td>{{ creationDate }}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{ form.updateUser && form.updateUser.name || '---' }}</td>
                <td>{{ updateDate }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>

        <!-- ACCIONES -->
        <div class="text-right" v-if="!readOnly">
          <b-button class="mr-2" size="lg" @click="onCancel">Cancelar</b-button>
          <b-button type="submit" variant="primary" size="lg" v-if="!readOnly">Guardar Permiso</b-button>
        </div>
      </b-form>

      <LoadingMask :active="loading"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Permission, PermissionRoleFilters, PermissionUpdate, Role, RoleCatalogFilters, RoleCatalogGridItem } from '@/types/Catalogs'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import ItemsTable from '@/components/generic/ItemsTable.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import catalogsService from '@/services/CatalogsService'
import { PermissionNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import { PageRequest } from '@/types/Support'
import moment from 'moment'
import DateFormat from '@/services/DateFormat'
import LogService, { ToString } from '@/services/support/LogService'

@Component({
  components: {
    LoadingMask,
    ItemsTable,
    MessageError
  }
})
export default class AdminPermissionForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  @Prop({ required: false, default: 0 })
  domainId: number

  loading: boolean = false
  loadingRoles: boolean = false

  form = Permission.getIntanceForEdit()
  formUpdated = PermissionUpdate.getIntanceForEdit()
  versionOptions = [
    { text: 'Versión 1', value: 1 },
    { text: 'Versión 2', value: 2 }
  ]
  domainOptions: any[] = []

  PAGE_SIZE = 500
  backupPermission = ''
  /** To work with role sections */
  filterRoles = new PermissionRoleFilters()
  allRoles: RoleCatalogGridItem[] = []
  creationDate = ''
  updateDate = ''

  mounted () {
    if (this.id) {
      this.loading = true
      catalogsService.getPermissionsById(this.id).then(data => {
        this.form = data
        this.filterRoles.roleIds = data.roles.map((role) => { return role.id })
        this.filterRoles.totalRoles = data.roles.length
        this.creationDate = data.creationDate ? new DateFormat(data.creationDate).toDateTimeString() : '- - / - - / - - - -'
        this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : '- - / - - / - - - -'
        if (this.form.domain !== -1) {
          catalogsService.getDomainById(this.form.domain).then((domain) => {
            this.domainOptions.push({ value: domain.id, text: domain.name })
          })
        }
      }).finally(() => {
        this.sincronizeFormUpdated(this.form, this.form.roles.map((role) => { return role.id }))
        this.backupPermission = JSON.stringify(this.formUpdated)
        this.loading = false
      })
    }
    this.domainOptions.push({ value: this.form.domain, text: 'GLOBAL' })
  }

  /** Permissions */

  /**
   * Checks if user has 'permissions:read'
   */
  get readPermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.PERMISSIONS_READ)
  }

  /**
   * Checks if user has 'permissions:update'
   */
  get updatePermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.PERMISSIONS_UPDATE)
  }

  /**
   * Checks if user has 'permissions:delete'
   */
  get deletePermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.PERMISSIONS_DELETE)
  }

  /** General actions */

  /**
   * Sincronizes 'formUpdated' with 'form' and assign 'rolesIds'
   * @param form - current permission being modified
   * @param roleIds - current role ids
   */
  sincronizeFormUpdated (form: Permission, roleIds: number[]) {
    this.formUpdated.id = form.id
    this.formUpdated.name = form.name
    this.formUpdated.domain = form.domain
    this.formUpdated.resource = form.resource
    this.formUpdated.effect = form.effect
    this.formUpdated.label = form.label
    this.formUpdated.version = form.version
    this.formUpdated.description = form.description
    this.formUpdated.roles = roleIds
    this.formUpdated.creationDate = form.creationDate
    this.formUpdated.creationUser = form.creationUser
    this.formUpdated.updateUser = form.updateUser
  }

  /**
   * Submits form values to save changes with a PUT/POST request
   */
  onSubmit () {
    this.sincronizeFormUpdated(this.form, this.filterRoles.roleIds)
    this.$validator.validateAll().then(result => {
      if (result && this.validateVersion()) {
        if (JSON.stringify(this.formUpdated) === this.backupPermission) {
          // If there are no changes then return to main grid
          this.onCancel()
          return
        }
        this.formUpdated.updateDate = new Date()
        if (this.id) {
          let msgConfirm = `Has realizado cambios en el registro: ${this.form.id} - ${this.form.name}. ¿Estás seguro de guardar los cambios?`
          this.$bvModal.msgBoxConfirm(msgConfirm, {
            title: 'Confirmar acción',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Confirmar',
            cancelVariant: 'outline-secondary',
            cancelTitle: 'Cancelar',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            hideHeaderClose: false
          }).then((value) => {
            if (value) {
              this.savePermission()
            }
          })
        } else {
          this.savePermission()
        }
      } else {
        this.$bvToast.toast('Revise los campos marcados con error', {
          title: 'Errores en el formulario',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 4500
        })
      }
    })
  }

  /**
   * POST/PUT request to save the form values
   */
  savePermission () {
    this.loading = true
    this.formUpdated.updateDate = new Date()
    catalogsService.savePermission(this.formUpdated).then((response: PermissionUpdate) => {
      this.formUpdated.id = response.id
      this.form.id = response.id
      this.$emit('saved', this.form)
    }).catch((error) => {
      let messageValues = {
        title: 'Error al guardar el permiso',
        message: '',
        delay: 10000,
        error: error
      }
      let errorComponent = new MessageError({ propsData: messageValues })
      errorComponent.displayMessage()
    }).finally(() => {
      this.loading = false
    })
  }

  /**
   * Switch to edit mode
   */
  changeEditMode () {
    this.$emit('edit-mode')
  }

  /**
   * Close form view
   */
  onCancel () {
    this.$emit('close')
  }

  /**
   * Generates automatically the name for permission
   */
  createName () {
    this.form.name = this.form.resource + ':' + this.form.effect
  }

  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  /**
   * Cheks if version has been selected
   */
  validateVersion () {
    if (this.form.version <= 0) {
      return false
    }
    return true
  }

  /**
   * Get all roles available and assign it in 'allRoles'
   */
  loadRoles (pageRequest: PageRequest<any>) {
    this.loadingRoles = true
    catalogsService.getRoles(pageRequest).then(response => {
      this.filterRoles.allRoles.push(...response.results.map((role: Role): RoleCatalogGridItem => {
        return this.generateRoleGrid(role, new RoleCatalogGridItem())
      }))
      if (this.filterRoles.allRoles.length < response.total) {
        pageRequest.page++
        this.loadRoles(pageRequest)
      }
    }).catch((error) => {
      LogService.error(`Error en la carga de roles: ${ToString(error.response)}`)
      this.loadingRoles = false
    }).finally(() => {
      this.loadingRoles = false
    })
  }

  /**
   * Update target role form origin role
   * @param origin - role entity to get values
   * @param target - roleCatalogGridItem to update
   * @returns a RoleCatalogGridItem updated
   */
  generateRoleGrid (origin: Role, target: RoleCatalogGridItem) {
    target.id = origin.id
    target.name = origin.name
    target.copyFromRole = origin.copyFromRole
    target.maxSessions = origin.maxSessions
    target.domain = origin.domain
    target.permissions = origin.permissions
    target.creation = origin.creationDate ? moment(origin.creationDate).format('DD/MM/YYYY') : '--'
    target.creationUser = origin.creationUser ? origin.creationUser.name : '---'
    target.update = origin.updateDate ? moment(origin.updateDate).format('DD/MM/YYYY') : '--'
    target.updateUser = origin.updateUser ? origin.updateUser.name : '---'
    return target
  }

  /**
   * Updates role ids on emit action from ItemsTable
   * @param newRoles that will add
   */
  updateRoles (newRoles: number[]) {
    this.filterRoles.roleIds = this.filterRoles.roleIds.concat(newRoles)
    this.formUpdated.roles = this.filterRoles.roleIds
    this.formUpdated.roles = this.filterRoles.allRoles.filter(role =>
      this.filterRoles.roleIds
        .includes(role.id))
      .map((role) => { return role.id })
  }

  /**
   * Remove role ids that was selected
   * @param roles that must remove
   */
  deleteRoles (roles: number[]) {
    this.filterRoles.roleIds = this.filterRoles.roleIds.filter(roleId => !roles.includes(roleId))
    this.form.roles = this.form.roles.filter(role => !roles.includes(role.id))
  }

  /**
   * Returns related roles from form
   */
  get relatedRoles () {
    let roles: any[] = []
    roles = roles.concat(this.form.roles)
    if (this.filterRoles.allRoles.length > 0) {
      this.filterRoles.allRoles.forEach(element => {
        if (!roles.find(role => role.id === element.id) && this.filterRoles.roleIds.includes(element.id)) {
          roles.push(element)
        }
      })
    }
    return roles
  }

  /**
   * Call loadRoles function
   */
  callLoadRoles () {
    this.filterRoles.allRoles = []
    let pageRequest = new PageRequest<RoleCatalogFilters>(this.PAGE_SIZE)
    if (userInfoStore.inRootDomain()) {
      pageRequest.filters.domain = this.domainId
    }
    this.loadRoles(pageRequest)
  }

  /**
   * Emit event to remove item
   */
  deleteItem () {
    this.$emit('delete-item')
  }

  /**
   * Updates current Permission to sincronized extern changes
   */
  sincronizeForm () {
    if (this.id) {
      this.loading = true
      catalogsService.getPermissionsById(this.id).then(data => {
        this.form = data
        this.filterRoles.roleIds = data.roles.map((role) => { return role.id })
        this.filterRoles.totalRoles = data.roles.length
      }).finally(() => {
        this.sincronizeFormUpdated(this.form, this.form.roles.map((role) => { return role.id }))
        this.backupPermission = JSON.stringify(this.formUpdated)
        this.loading = false
      })
    }
  }
}
</script>
